<template>
  <ul ref="navs" :class="classes" :style="styles">
    <slot></slot>
    <li v-if="showRest && mode=='horizontal'" :class="navItemClasses">
      <t-dropdown offset="-4px">
        <div slot="trigger">
          <div style="padding:0 10px;">
            <t-icon icon="dots-horizontal"></t-icon>
            <div class="navs__space"></div>
          </div>
        </div>
        <div slot="popper">
          <t-navs-rest :type="type" :active-name="activeName" :items="resetItem" @menu-item-select="$_selectItem"></t-navs-rest>
        </div>
      </t-dropdown>
    </li>
  </ul>
</template>
<script>
import { PREFIX_CLASS } from '../../utils/constants'
import { addClass, removeClass } from '@/utils/helper.js'
import bus from '../../utils/bus'
const PREFIX_MENU_CLASS = `${PREFIX_CLASS}navs`

export default {
  name: 'TNavs',
  provide() {
    return {
      groupVM: this
    }
  },
  components: {
    't-navs-rest': {
      name: 'TNavsRest',
      props: {
        type: String,
        items: Object,
        activeName: {
          type: [String, Number],
          default: ''
        }
      },
      methods: {
        $_selectItem(name, navItemName) {
          this.$emit('menu-item-select', name)
        }
      },
      render(h) {
        return (
          <div class={['mod-rest', 'mod-rest__' + this.type]}>
            <t-menu type={this.type} active-name={this.activeName} open-position="right" on-on-select={this.$_selectItem}>
              {
                this._l(this.items, (item, key) => {
                  // return item.$slots.default
                  if (item.$slots.default) {
                    return (
                      <t-menu-item name={key}>
                        { item.$slots.default}
                      </t-menu-item>
                    )
                  }
                  if (item.$slots.title && item.$slots.subNav && item.$slots.subNav[0] && item.$slots.subNav[0].child) {
                    return (
                      <t-submenu name={key}>
                        <template slot="title">
                          {item.$slots.title}
                        </template>
                        {item.$slots.subNav[0].child.$scopedSlots.default()}
                      </t-submenu>
                    )
                  }
                })
              }
            </t-menu>
          </div>
        )
      }
    }
  },
  props: {
    mode: {
      type: String,
      validator(value) {
        return ['horizontal', 'vertical'].includes(value)
      },
      default: 'horizontal'
    },
    type: {
      type: String,
      validator(value) {
        return ['light', 'dark', 'ghost'].includes(value)
      },
      default: 'light'
    },
    activeName: {
      type: [String, Number],
      default: ''
    },
    width: {
      type: String,
      default: ''
    },
    threshold: {
      type: Number,
      default: 7
    }
  },
  data() {
    return {
      items: {},
      currentActiveName: ''
    }
  },
  computed: {
    classes() {
      let type = this.type
      if (this.mode === 'vertical' && this.type === 'primary') type = 'light'

      return [
        `${PREFIX_MENU_CLASS}`,
        `${PREFIX_MENU_CLASS}--${type}`,
        {
          [`${PREFIX_MENU_CLASS}--${this.mode}`]: this.mode
        }
      ]
    },
    navItemClasses() {
      return [
        `${PREFIX_MENU_CLASS}__item`,
        `${PREFIX_MENU_CLASS}__rest`
      ]
    },
    styles() {
      let style = {}
      if (this.mode === 'vertical') style.width = this.width
      return style
    },
    resetItem() {
      let item = {}
      Object.keys(this.items).forEach((key, index) => {
        if (index >= this.threshold) {
          item[key] = { ...this.items[key] }
          addClass(item[key].$el, 'd-none')
        }
      })
      return item
    },
    showRest() {
      return Object.keys(this.items).length > this.threshold
    }
  },
  watch: {
    activeName(val) {
      this.$_updateActiveName(val)
    },
    threshold(val) {
      Object.keys(this.items).forEach((key, index) => {
        let item = this.items[key]
        if (index >= val) {
          addClass(item.$el, 'd-none')
        } else {
          removeClass(item.$el, 'd-none')
        }
      })
    }
  },
  mounted() {
    this.$_updateActiveName(this.activeName)
    this.$on('menu-item-select', name => {
      this.$_selectItem(name)
      bus.$emit('clearActiveName')
    })
  },
  methods: {
    $_selectItem(name) {
      this.$_updateActiveName(name)
      this.$emit('update:activeName', name)
      this.$emit('on-select', name)
    },
    $_addItem(item) {
      this.$set(this.items, item.name, item)
    },
    $_removeItem(item) {
      delete this.items[item.name]
    },
    getLiDom(dom) {
      if (dom.className !== 'navs__item') {
        return this.getLiDom(dom.parentNode)
      } else {
        return dom
      }
    },
    isHidden(el) {
      var style = window.getComputedStyle(el)
      return (style.display === 'none')
    },
    $_updateActiveName(newActiveName) {
      this.currentActiveName = newActiveName
      this.$nextTick(() => {
        this.broadcast(
          'on-update-active-name',
          (this.currentActiveName !== undefined ? this.currentActiveName : -1)
        )
      })
    },
    broadcast(eventName, params) {
      this.$children.forEach(child => {
        child.$emit.apply(child, [eventName].concat(params))
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/module/navs/navs.vue